import img1 from "../../image/Image _ Page/Service_popup/Infastructure Solution-main.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/Infastructure Solution-1.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/Infastructure Solution-2.jpeg";
import "../../Components/style/infa.css";
import React, { useState } from 'react';
import {
  FaShieldAlt,
  FaDesktop,
  FaCode,
  FaNetworkWired,
  FaVideo,
  FaFingerprint,
  FaDatabase,
  FaUserTie,
  FaTools,
  FaClock,
  FaToolbox,
} from "react-icons/fa";

// Blue/white icon-card data for the "solution-card" section.
// shortText always shows; moreText only shows when expanded via the Read More toggle.
const SOLUTION_CARDS = [
  {
    icon: <FaShieldAlt size={20} />,
    title: "Enterprise Storage",
    shortText: "We deliver expert storage system integration, handling everything from needs assessment and design to",
    moreText: "installation and support. Our focus is on seamlessly integrating scalable architectures like SAN/NAS and HCI to optimize data management and growth.",
  },
  {
    icon: <FaDesktop size={20} />,
    title: "Server Virtualization",
    shortText: "We offer professional server virtualization integration, specializing in VMware and Hyper-V.",
    moreText: "Our services cover solution design, procurement, deployment, consolidation, and ongoing management to maximize efficiency and minimize downtime.",
  },
  {
    icon: <FaCode size={20} />,
    title: "Virtual Desktop Infrastructure (VDI)",
    shortText: "We provide and integrate VDI solutions, delivering end-to-end services",
    moreText: "from planning and procurement to deployment, configuration, and management. Our integrated solutions enhance security and support flexible work environments.",
  },
  {
    icon: <FaNetworkWired size={20} />,
    title: "Data Center Infrastructure",
    shortText: "We specialize in data center infrastructure integration, offering complete solutions from design",
    moreText: "and planning to deployment and support. Our expertise includes integrating modern, energy-efficient data centers with a focus on HCI.",
  },
  {
    icon: <FaVideo size={20} />,
    title: "Cloud Integration and Hybrid Solutions",
    shortText: "We provide comprehensive cloud integration and hybrid cloud solutions,",
    moreText: "offering strategy, planning, procurement, deployment, and management services. We expertly integrate with platforms like AWS, Azure, and GCP for scalable cloud environments.",
  },
  {
    icon: <FaFingerprint size={20} />,
    title: "Infrastructure Automation",
    shortText: "We deliver expert infrastructure automation integration services to streamline IT operations. This",
    moreText: "includes solution design, procurement, implementation, and management of IaC solutions, along with application monitoring.",
  },
  {
    icon: <FaDatabase size={20} />,
    title: "Backup and Disaster Recovery",
    shortText: "We provide and integrate comprehensive backup and disaster recovery solutions, offering complete",
    moreText: "services from planning and procurement to implementation and support. Our solutions focus on integrating robust strategies for server, database, and cloud backup.",
  },
];

// Blue/white rectangle-card data for the "quality" section list.
const QUALITY_ITEMS = [
  {
    icon: <FaUserTie size={36} color="#2563EB" />,
    title: "Proven Expertise",
    desc: "A demonstrated history of successful enterprise infrastructure implementations and satisfied clients.",
  },
  {
    icon: <FaTools size={36} color="#2563EB" />,
    title: "Industry Best Practices",
    desc: "Adherence to industry-leading methodologies for design, deployment, and management.",
  },
  {
    icon: <FaToolbox size={36} color="#2563EB" />,
    title: "Performance & Reliability Assurance",
    desc: "Rigorous testing and validation to ensure optimal performance, reliability, and security.",
  },
  {
    icon: <FaClock size={36} color="#2563EB" />,
    title: "Proactive Support & Monitoring",
    desc: "Continuous monitoring and dedicated support to address potential issues and maximize uptime.",
  },
];

const Infastructure = () => {
  // State to manage visibility of full content for each solution card
  const [showFullContent, setShowFullContent] = useState(Array(SOLUTION_CARDS.length).fill(false));

  const toggleCard = (i) => {
    const next = [...showFullContent];
    next[i] = !next[i];
    setShowFullContent(next);
  };

  return (
    <div>
      {/**this is banner section  */}
      <div style={{ position: "relative", width: "100%", height: "60vh" }}>
        {/* Image */}
        <img
          src={img1}
          alt="Inner Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        {/* Centered Text */}
        <h2
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "3rem",
            fontWeight: "bold",
            textAlign: "center",
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
          }}
        >
          Computing, Storage & Virtualization
        </h2>
      </div>
      <section className="about-services-section">
        <div className="container">
          <div className="content-wrapper">
            {/* Image Box */}
            <div className="image-box">
              <img src={img2} alt="IT Solution" className="service-image" />
              <div className="image-overlay">
                <span className="overlay-text">Explore More</span>
              </div>
            </div>

            {/* Text Box */}
            <div className="text-box">
              <h5 className="section-subtitle">Enterprise Computing, Storage & Virtualization Solutions</h5>
              <h2 className="section-title">
                Optimize Your Enterprise Infrastructure with{" "}
                <span className="highlight-text"> Emicron Techsolutions</span>
              </h2>
              <p className="section-description">
                Revolutionize your enterprise computing, storage, and virtualization landscape to achieve unparalleled efficiency and scalability. We deliver customized solutions that simplify complex environments, empowering your business to thrive.
              </p>
              <p className="section-description">
                From strategic design to ongoing maintenance, we ensure the seamless operation of your critical technology foundation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ SOLUTION CARDS (blue/white icon-card grid, 3 per row, with Read More expand) ============ */}
      <section style={{ padding: "60px 40px", background: "#F3F6FC" }}>
        <style>{`
          @media (max-width: 900px) {
            .orryx-infa-solution-grid { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 560px) {
            .orryx-infa-solution-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            className="orryx-infa-solution-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {SOLUTION_CARDS.map((card, i) => (
              <div
                key={card.title}
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "26px",
                  boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: "#DCE6FB",
                    color: "#2563EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  {card.icon}
                </div>
                <h5 style={{ fontSize: "16px", fontWeight: 700, margin: 0, marginBottom: "8px", color: "#111827" }}>
                  {card.title}
                </h5>
                <p style={{ fontSize: "13.5px", color: "#6B7280", lineHeight: 1.6, margin: 0 }}>
                  {card.shortText}{" "}
                  {showFullContent[i] && <span>{card.moreText}</span>}
                </p>
                <button
                  onClick={() => toggleCard(i)}
                  style={{
                    marginTop: "14px",
                    background: "none",
                    border: "none",
                    color: "#2563EB",
                    fontWeight: 600,
                    fontSize: "13px",
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  {showFullContent[i] ? "Show Less" : "Read More →"}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ QUALITY SECTION (blue/white rectangle boxes, centered) ============ */}
      <section className="quality" style={{ width: "100%" }}>
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <div
            className="quality-content"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              maxWidth: "100%",
              flex: "none",
            }}
          >
            <div className="para">
              <p>Ensuring Exceptional Quality in Enterprise Computing, Storage & Virtualization Services</p>
            </div>
            <div className="quaity-head">
              <h2>
                Our Commitment to Delivering Reliable, Secure, and High-Performance Solutions
              </h2>
            </div>
            <ul className="list-item" style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", width: "100%" }}>
              {QUALITY_ITEMS.map((item) => (
                <li key={item.title} style={{ width: "100%", maxWidth: "620px" }}>
                  <div
                    className="list-box"
                    style={{
                      background: "#fff",
                      borderRadius: "14px",
                      boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                      padding: "22px 26px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "12px",
                    }}
                  >
                    <div className="list-icon">
                      {item.icon}
                    </div>
                    <div>
                      <h4 style={{ margin: 0, marginBottom: "6px", fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                        {item.title}
                      </h4>
                      <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Infastructure;
